export default {
  en: {
    menu_multilingualism: "Welcome",
    menu_about: "About",
    menu_solutions: "Solutions",
    menu_contact: "Contact",
    multilingualism_title: "Multilingualism made easy",
    multilingualism_content: `
      <p>
        Are your multilingual teams struggling to communicate effectively?
      </p>
      <p>
        At Etymo*, we help bridge the gap with tailored <b>consulting tracks</b>, customized <b>workshops</b>, engaging <b>language coaching</b> and bespoke <b>writing services</b>.
      </p>
      <p>
      Boost collaboration, empower your coworkers, and create a truly unified multilingual workplace.
      </p>`,
    about_title: "About Etymo*",
    about_content: `
      <p>
        So, you've invested in language training for your coworkers, but you still feel they don't really use their second language at work.
        <br>
        Or you've been learning a second language for a while, but you never get the chance to speak it at the office - despite having native speakers as colleagues.
      </p>
      <p>
        Sound familiar?
        <br>
        Welcome to Etymo*.
      </p>
      <p>
        My name is Melissa, and I've been a corporate language trainer (EN/NL/FR) since 2017.
        <br>
        In that time, I've found that language learners rarely practice their second language at work if they don't feel empowered to do so - which can be quite an obstacle in multilingual teams.
      </p>
      <p>
        How can you empower your multilingual teams to communicate better?
        <br>
        How can multilingualism become an asset and not an obstacle?
      </p>
      <p>
        Let Etymo* help you find out.
      </p>`,
    solution_title_main: "Solutions",
    solution_title_1: "Multilingualism Consulting & Coaching",
    solution_content_1: "Bespoke consulting & coaching tracks to help your multilingual teams work better together.",
    solution_title_2: "Workshops",
    solution_content_2: "Customized trilingual workshops in Dutch, French and English to improve communication and cohesion within multilingual teams. ",
    solution_title_3: "Language Training",
    solution_content_3: "Dutch, French and English language training, for individual learners or small groups. Always closely tailored to your learners' and your organization's needs.",
    solution_title_4: "Writing Services",
    solution_content_4: "Proofreading, editing and ghostwriting. For all your content in Dutch, French and English. ",
    contact_title: "Get in Touch",
    contact_name: "Name",
    contact_email: "Email",
    contact_message: "Message",
    contact_send: "Send",
  },
  fr: {
    menu_multilingualism: "Bienvenue",
    menu_about: "À propos",
    menu_solutions: "Solutions",
    menu_contact: "Contact",
    multilingualism_title: "Le multilinguisme simplifié",
    multilingualism_content: `
      <p>
        Vos équipes multilingues ont du mal à communiquer de manière efficace ?
      </p>
      <p>
        Chez Etymo*, nous facilitons la collaboration multilingue grâce à des programmes de <b>consultance</b> sur mesure, des <b>ateliers</b> personnalisés, un <b>coaching linguistique</b> motivant et des services de <b>rédaction</b> adaptés à vos besoins.
      </p>
      <p>
        Renforcez la collaboration, valorisez vos équipes et créez un environnement de travail véritablement unifié et multilingue.
      </p>`,
    about_title: "À propos d'Etymo*",
    about_content: `
      <p>
        Vous avez investi dans la formation linguistique de vos collaborateurs, mais vous avez l'impression qu'ils n'utilisent pas vraiment leur deuxième langue au travail. 
        <br>
        Vous apprenez vous-même une deuxième langue depuis un certain temps, mais vous n'avez jamais l'occasion de la parler au bureau, même si vous avez des collègues natifs. 
      </p>
      <p>
        Ça vous semble familier ?
        <br>
        Bienvenue chez Etymo*.
      </p>
      <p>
        Je m'appelle Melissa, et je suis formatrice de langues en entreprise (EN/NL/FR) depuis 2017.
        <br>
        Au fil des années, j'ai constaté que les apprenants en langues pratiquent rarement leur deuxième langue au travail s'ils ne se sentent pas à l'aise pour le faire - ce qui peut représenter un obstacle important dans les équipes multilingues.
      </p>
      <p>
        Comment booster vos équipes multilingues pour qu'elles communiquent mieux ?
        <br>
        Comment transformer le multilinguisme en atout et non pas en obstacle ?
      </p>
      <p>
        Etymo* vous aidera à le découvrir.
      </p>`,
    solution_title_main: "Solutions",
    solution_title_1: "Consultance & Coaching en Multilinguisme",
    solution_content_1: "Programmes sur mesure de consultance et de coaching pour aider vos équipes multilingues à mieux travailler ensemble.",
    solution_title_2: "Ateliers",
    solution_content_2: "Ateliers trilingues personnalisés (néerlandais, français, anglais) pour améliorer la communication et la cohésion au sein de vos équipes multilingues. ",
    solution_title_3: "Formations en Langues",
    solution_content_3: "Formations en néerlandais, français et anglais, pour apprenants individuels ou en petits groupes. Toujours adaptées aux besoins de vos apprenants et de votre organisation.",
    solution_title_4: "Services de Rédaction",
    solution_content_4: "Relectures, corrections et services de prête-plume. Pour tous vos contenus en néerlandais, français et anglais.",
    contact_title: "Contactez-nous",
    contact_name: "Nom",
    contact_email: "Email",
    contact_message: "Message",
    contact_send: "Envoyer",
  },
  nl: {
    menu_multilingualism: "Welkom",
    menu_about: "Over Etymo*",
    menu_solutions: "Oplossingen",
    menu_contact: "Contact",
    multilingualism_title: "Meertaligheid, maar dan eenvoudig",
    multilingualism_content: `
      <p>
        Verloopt de communicatie moeizaam binnen uw meertalige teams? 
      </p>
      <p>
        Bij Etymo* bieden we oplossingen met custom <b>consultingtrajecten</b>, aangepaste <b>workshops</b>, boeiende <b>taalcoaching</b> en <b>schrijfdiensten</b> op maat.
      </p>
      <p>
        Boost het zelfvertrouwen van uw teams en creëer een omgeving waar alle collega’s zich op hun gemak voelen om efficiënt te communiceren.  
      </p>`,
    about_title: "Over Etymo*",
    about_content: `
      <p>
        U investeert in taaltraining voor uw medewerkers, maar u hebt het gevoel dat ze hun tweede taal op het werk niet echt gebruiken.
        <br>
        Of u bent misschien zelf al een tijdje bezig met het leren van een tweede taal, maar u krijgt nooit de kans om deze op kantoor te spreken - ook al werkt u samen met moedertaalsprekers.
      </p>
      <p>
        Komt dit u bekend voor?
        <br>
        Welkom bij Etymo*.
      </p>
      <p>
        Ik ben Melissa en sinds 2017 ben ik corporate taaltrainer (EN/NL/FR). 
        <br>
        In die tijd heb ik gemerkt dat taalcursisten zelden hun tweede taal op het werk oefenen als ze zich niet genoeg op hun gemak voelen - wat een behoorlijke hindernis kan zijn in meertalige teams.
      </p>
      <p>
        Hoe kunt u uw meertalige teams helpen om beter te communiceren?
        <br>
        Hoe kan meertaligheid een troef worden en geen obstakel?
      </p>
      <p>
        Etymo* helpt u hierbij.
      </p>`,
    solution_title_main: "Oplossingen",
    solution_title_1: "Consulting en Coaching rond Meertaligheid",
    solution_content_1: "Op maat gemaakte consulting- & coachingstrajecten om uw meertalige teams te helpen beter samen te werken.",
    solution_title_2: "Workshops",
    solution_content_2: "Aangepaste drietalige workshops in het Nederlands, Frans en Engels, om de communicatie en samenwerking binnen meertalige teams te verbeteren.",
    solution_title_3: "Taaltraining",
    solution_content_3: "Taaltraining Nederlands, Frans en Engels, voor individuele cursisten of kleine groepjes. Altijd nauw afgestemd op de behoeften van uw cursisten en uw organisatie.",
    solution_title_4: "Schrijfdiensten",
    solution_content_4: "Proofreading, tekstbewerking en ghostwriting. Voor al uw content in het Nederlands, Frans en Engels.",
    contact_title: "Contacteer ons",
    contact_name: "Naam",
    contact_email: "Email",
    contact_message: "Bericht",
    contact_send: "Verzenden",
  }
};
